// https://i18n.nuxtjs.org/guide/lang-switcher#dynamic-route-parameters
import type { SeoAttributesOptions } from "@nuxtjs/i18n";
import type { ProductDetailItem } from "~~/models/products";
import { getUrlCodeFromLanguageCode } from "~~/server/utils/mapping/localeMapping";

export function useProductSlugsToI18n(product: ProductDetailItem | undefined) {
  if (!product?.urls) {
    return;
  }

  // Map language codes (fr, nl) to locale codes (fr-be, nl-be)
  const localizedUrls = mapToLocaleUrls(product.urls);

  // https://i18n.nuxtjs.org/docs/composables/use-set-i18n-params
  const setI18nParams = useSetI18nParams({
    canonicalQueries: [],
  } as SeoAttributesOptions);

  setI18nParams(localizedUrls);
};

/**
 * Converts language codes to locale codes
 * @param urls Object with language codes as keys
 * @returns Object with locale codes as keys
 */
function mapToLocaleUrls(urls: Record<string, { slug: string }>): Record<string, { slug: string }> {
  return Object.entries(urls).reduce((result, [lang, data]) => {
    // Convert language code to locale code by adding "-be"
    const localeCode = getUrlCodeFromLanguageCode(lang);

    return {
      ...result,
      [localeCode]: data,
    };
  }, {});
}
